import { MouseEvent, useState } from 'react';
import styled from '@emotion/styled';
import { Chip, IconButton, Tooltip } from '@mui/material';

import { useAppSelector } from '@/redux/hooks';
import { selectDataTableSorting } from '@/redux/selectors/dataTableSelectors';
import { PolarisIcon } from '@/exports/columnCommonComponents';
import AdvanceSortMenu from '@/components/_common/Table/AdvanceSort/AdvanceSortMenu';

function AdvanceSortButton() {
  const sorting = useAppSelector(selectDataTableSorting);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title="Advanced Sort">
        {sorting && sorting.length > 1 ? (
          <StyledChip
            color="primary"
            label={
              <>
                <PolarisIcon icon="swap" fontWeight="bold" />
                <StyledBadge>{sorting.length}</StyledBadge>
              </>
            }
            onClick={handleClick}
          />
        ) : (
          <IconButton size="small" onClick={handleClick}>
            <PolarisIcon icon="swap" />
          </IconButton>
        )}
      </Tooltip>
      <AdvanceSortMenu isOpen={open} anchorEl={anchorEl} onClose={handleClose} />
    </>
  );
}

export default AdvanceSortButton;

const StyledChip = styled(Chip)(({ theme }) => ({
  cursor: 'pointer',
  margin: `0 ${theme.spacing(0.5)}`,
  '& .MuiChip-label': {
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(1),
    fontSize: theme.typography.fontSize,
    fontWeight: theme.typography.fontWeightBold
  }
}));

const StyledBadge = styled.div(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  borderRadius: '50%',
  fontSize: theme.typography.caption.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
  minWidth: 24,
  minHeight: 24,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));
